import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccessRequestPageComponent } from '../core/containers/access-request/access-request-page.component';
import { RotaAuthGuardService } from './services/auth-guard.service';

export const routes: Routes = [
  {
    path: 'access-request',
    component: AccessRequestPageComponent,
  },
  {
    path: '',
    canActivate: [RotaAuthGuardService],
    children: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RotaRoutingModule {}
